<template>
  <div class="service-bottom-sticky">
    <a href="#" @click.prevent="openInstructions">
      <i class="icon-sc-chevron-down flip-v"></i>
      <span>{{ $t('digitalServices.sidebar.items.instructions') }}</span>
    </a>
  </div>
</template>

<script>
import { menuMap } from '@/components/common/navigation/config/digitalServicesSidebarConfig'

export default {
  name: 'digital-instruction-sticky-button',
  props: {
    serviceName: {
      type: String,
      default: ''
    }
  },
  computed: {
    instructionName () {
      const serviceItem = menuMap.find(item => item.name === this.$props.serviceName)
      if (serviceItem) {
        return serviceItem.submenu.filter(subItem => subItem.name.includes('instruction'))[0].name
      }
      return ''
    }
  },
  methods: {
    /**
     * Opens instructions for selected service. The service is passed as a prop
     */
    openInstructions () {
      this.$parent.$emit('open-page', { name: this.instructionName })
    }
  }
}
</script>

<style scoped lang="scss">
.service-bottom-sticky {
  z-index: 3;
  position: fixed;
  top: auto;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  background: $white;
  color: $text;
  box-shadow: 0 -3px 15px 0 rgba(0, 0, 0, 0.08);
  border-radius: 10px 10px 0 0;
  padding: 2.4rem 1.6rem 0.8rem;
  text-align: center;

  @media (map_get($breakpoints, md)) {
    display: none;
  }

  a {
    font-size: 15px;
    font-weight: bold;
    color: $text;
    user-select: none;
    display: block;

    i.flip-v {
      display: inline-block;
      color: $primary;
      transform: rotateX(180deg);
      margin-bottom: 0.8rem;
    }

    span {
      display: block;
      text-align: center;
    }
  }
}
</style>
